export const WebRTCInputEnum = {
  videoInput: "videoinput",
  audioInput: "audioinput",
  resolutionInput: "resolutioninput",
  screenInput: "screeninput",
};
